import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, IconButton, Menu, Modal, Stack, TextField, Tooltip, Typography, useTheme, } from "@mui/material";
import TableComponent from "components/grid";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAllActivitiesQuery } from "store/slices/apis/documentsSlice";
import moment from "moment";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { GrDocumentUpload } from "react-icons/gr";
import { FilterList } from "@mui/icons-material";
import { FaList } from "react-icons/fa6";
import { usePermission } from "hooks/usePermission";
import { ENGINEERING_MANAGE_DRAWING } from "config";
import { ReactComponent as FilterIcon } from "assets/PwC_Funct_Icons_ListPlay_Outline_Black_RGB.svg"
import { ReactComponent as ListIcon } from "assets/PwC_Funct_Icons_ListView_Fill_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Allactivities = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const activitAccess = usePermission(ENGINEERING_MANAGE_DRAWING);
    const { projectId, activityId } = useParams();

    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [activityName, setActivityName] = useState(null);

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        search: ""
    });

    const [allActivitiesListData, setAllActivitiesListData] = useState([]);

    const { data: allActivitiesList, isLoading, isSuccess: allActivitiesIsSuccess } = useGetAllActivitiesQuery({
        projectId: projectId,
        page: pageNumber,
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        search: filters?.search,
        pageSize: 10
    });

    useEffect(() => {
        if (allActivitiesIsSuccess) {
            setAllActivitiesListData(allActivitiesList?.data?.data)
        }
    }, [allActivitiesList, allActivitiesIsSuccess])


    const columns = [
        {
            name: "Activity Name",
            field: "activityName",
        },
        {
            name: "Plan Start Date",
            field: "startDate",
            renderer(params) {
                return (
                    <>
                        {params?.baselineStartDate
                            ? moment(params.baselineStartDate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
        },
        {
            name: "Plan End Date",
            field: "endDate",
            renderer(params) {
                return (
                    <>
                        {params?.baselineEndDate
                            ? moment(params.baselineEndDate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
        },
        {
            name: "Accepted Document",
            field: "accepted",
            width: 90
        },
        {
            name: "Pending Document",
            field: "pending",
            width: 90
        },
        {
            name: "Reject Document",
            field: "rejected",
            width: 90
        },
        // {
        //     name: "Created Date",
        //     field: "createdDate",
        //     renderer(params) {
        //         return (
        //             <>
        //                 {params?.createdDate
        //                     ? moment(params.createdDate).format("DD/MM/YYYY")
        //                     : ""}
        //             </>
        //         );
        //     },
        // },

    ];

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const openFilter = Boolean(filterAnchorEl);

    const handleFilterClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterClose = () => {
        setFilterAnchorEl(null);
    };

    const handleSearchChange = (e) => {
        setActivityName(e.target.value);
    };

    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
    );

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                            <TextField
                                value={activityName}
                                onChange={handleSearchChange}
                                placeholder="Search by activity name"
                                InputProps={{
                                    style: {
                                        fontSize: "16px",
                                    },
                                }}
                                sx={{
                                    // width: 250,
                                    width: { xs: "100%", sm: 250 },
                                    "& .MuiInputBase-root": {
                                        height: "43px",
                                        marginTop: { xs: 0, sm: '17px' },
                                        // backgroundColor:'#fff'                                      
                                    },
                                    "& .MuiInputBase-input": {
                                        fontSize: "16px",
                                        lineHeight: "20px",
                                        fontWeight: "400",
                                        color: "#696969",
                                        opacity: 1,
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                        fontSize: "16px",
                                        lineHeight: "20px",
                                        fontWeight: "400",
                                        color: "#696969",
                                        opacity: 1,
                                    },
                                }}
                            />
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    // width: 100,
                                                    width: { xs: "100%", sm: 100 },
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: "",
                                                        toDate: toDate
                                                            ? dayjs(toDate).format("YYYY-MM-DD")
                                                            : "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        clearable={true}
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    width: { xs: "100%", sm: 100 },
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: fromDate
                                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                                            : "",
                                                        toDate: "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFilters({
                                        fromDate: fromDate
                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                            : "",
                                        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                                        search: activityName
                                    });
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFromDate(null)
                                    setToDate(null)
                                    setActivityName('')
                                    const clearedValues = Object.fromEntries(
                                        Object.keys(filters).map(key => [key, ""])
                                    );
                                    setFilters(clearedValues);
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                        {/*<Button
                            variant="outlined"
                            onClick={handleFilterClick}
                            // startIcon={<FilterList />}
                            startIcon={<FilterIcon style={{ height: "24px", width: "24px", fill:`${theme?.customSettings?.themeColor}` }} />}
                            sx={{
                                color: `${theme?.customSettings?.themeColor}`,
                                border: `1px solid ${theme?.customSettings?.themeColor}`,
                                background: "none",
                                textTransform: "inherit",
                                padding: "6px 15px",
                                marginTop: "12px !important",
                            }}
                        >
                            Filter
                        </Button>
                        <Menu
                            anchorEl={filterAnchorEl}
                            open={openFilter}
                            onClose={handleFilterClose}
                            PaperProps={{
                                sx: {
                                    width: 400,
                                    maxWidth: "100%",
                                    boxShadow: "none",
                                    border: "1px solid #eee",
                                    padding: 2,
                                },
                            }}
                        >
                            <Grid2 container spacing={2}>
                                <Grid2 size={12}>
                                    <TextField
                                        // value={searchQuery}
                                        // onChange={handleSearchChange}
                                        placeholder="Search by activity name"
                                        InputProps={{
                                            style: {
                                                fontSize: "16px",
                                            },
                                        }}
                                        sx={{
                                            width: '100%',
                                            "& .MuiInputBase-root": {
                                                height: "43px",
                                                marginTop: '17px',
                                                // backgroundColor:'#fff'                                      
                                            },
                                            "& .MuiInputBase-input": {
                                                fontSize: "16px",
                                                lineHeight: "20px",
                                                fontWeight: "400",
                                                color: "#696969",
                                                opacity: 1,
                                            },
                                            "& .MuiInputBase-input::placeholder": {
                                                fontSize: "16px",
                                                lineHeight: "20px",
                                                fontWeight: "400",
                                                color: "#696969",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                </Grid2>
                            </Grid2>

                            <Grid2 size={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                    <DemoContainer components={["DatePicker", "DatePicker"]}>
                                        <DatePicker
                                            label="From Date"
                                            value={fromDate}
                                            format="DD-MM-YYYY"
                                            onChange={(newValue) => setFromDate(newValue)}
                                            slotProps={{
                                                textField: {
                                                    sx: {
                                                        width: '100%',
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "10px",
                                                        },

                                                        "& .MuiInputLabel-root": {
                                                            top: "-6px",
                                                        },
                                                    },
                                                },
                                                field: {
                                                    clearable: true,
                                                    onClear: () =>
                                                        setFilters({
                                                            fromDate: "",
                                                            toDate: toDate
                                                                ? dayjs(toDate).format("YYYY-MM-DD")
                                                                : "",
                                                        }),
                                                },
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 size={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={["DatePicker", "DatePicker"]}>
                                        <DatePicker
                                            label="To Date"
                                            value={toDate}
                                            format="DD-MM-YYYY"
                                            clearable={true}
                                            onChange={(newValue) => setToDate(newValue)}
                                            slotProps={{
                                                textField: {
                                                    sx: {
                                                        width: '100%',
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "10px",
                                                        },

                                                        "& .MuiInputLabel-root": {
                                                            top: "-6px",
                                                        },
                                                    },
                                                },
                                                field: {
                                                    clearable: true,
                                                    onClear: () =>
                                                        setFilters({
                                                            fromDate: fromDate
                                                                ? dayjs(fromDate).format("YYYY-MM-DD")
                                                                : "",
                                                            toDate: "",
                                                        }),
                                                },
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid2>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    loading={isLoading}
                                    onClick={() => {
                                        setFilters({
                                            fromDate: fromDate
                                                ? dayjs(fromDate).format("YYYY-MM-DD")
                                                : "",
                                            toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : ""
                                        });
                                    }}
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        color: `${theme?.customSettings?.themeColor}`,
                                        border: `1px solid ${theme?.customSettings?.themeColor}`,
                                        background: "none",
                                        textTransform: "inherit",
                                        padding: "6px 15px",
                                        marginTop: "12px !important",
                                        marginRight: '10px'
                                    }}
                                >
                                    Search
                                </Button>
                                <Button
                                    loading={isLoading}
                                    onClick={() => {
                                        setFromDate(null)
                                        setToDate(null)
                                        const clearedValues = Object.fromEntries(
                                            Object.keys(filters).map(key => [key, ""])
                                        );
                                        setFilters(clearedValues);
                                    }}
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        color: `${theme?.customSettings?.themeColor}`,
                                        border: `1px solid ${theme?.customSettings?.themeColor}`,
                                        background: "none",
                                        textTransform: "inherit",
                                        padding: "6px 15px",
                                        marginTop: "12px !important",
                                    }}
                                >
                                    Reset
                                </Button>
                                {/* <Button onClick={handleFilterClose} sx={{ mr: 1 }}>Cancel</Button>
                                    <Button type="submit" variant="contained">Apply</Button> 
                            </Box>

                        </Menu> */}

                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 1 }}>
                    <TableComponent
                        columns={[
                            ...columns,
                            ...[
                                activitAccess && {
                                    name: "Manage Drawing",
                                    width: 90,
                                    renderer(params) {
                                        return (
                                            <Tooltip
                                                placement="top"
                                                title="View & Add Drawing"
                                                arrow
                                                slotProps={{ tooltip: { sx: { fontSize: "12px" } } }}
                                            >
                                                <IconButton
                                                    aria-label="download"
                                                    size="small"
                                                    onClick={() =>
                                                        navigate(`/projects/${projectId}/documents/all-documents/${params?.id}`)
                                                    }
                                                >
                                                    {/* <FaList style={{ height: "20px", width: "20px" }} /> */}
                                                    <ListIcon style={{ height: "20px", width: "20px", fill: "#37352F", fillOpacity: 0.8 }} />
                                                </IconButton>
                                            </Tooltip>
                                        );
                                    },
                                },
                            ].filter(Boolean),
                        ]}
                        data={allActivitiesListData}
                        type="border"
                    />
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                        <PaginationComponent
                            pageNumber={allActivitiesList?.data?.pagination?.currentPage || 1}
                            totalPages={allActivitiesList?.data?.pagination?.totalPages || 1}
                            onPageChange={setPageNumber}
                        />
                    </Box>
                </Grid2>
            </Grid2 >
        </>
    );
}

export default Allactivities;
